import React from 'react';
import { Text, View, StyleSheet, ScrollView } from 'react-native';

import {
  __WEB__,
  COLOR,
  FONT,
  FONT_SIZE,
  THEME,
  SELECT_STYLE_ROUND,
} from '../../../constants/styles';
import {
  PRIMARY_ROSTER_MED_SERVICE as PRIMARY_ROSTER,
  SECONDARY_ROSTER_MED_SERVICE as SECONDARY_ROSTER,
  ALTERNATE_ROSTER_MED_SERVICE as ALTERNATE_ROSTER,
} from '../../../constants/medical_roster';

import { REQUESTING, SUCCESS } from '../../../actions/statusTypes';
import * as ASSETS from '../../../constants/assets';

import moment from 'moment-timezone';

import {
  OPComponent,
  Container,
  I18n,
  Utils,
  Navigation,
  NavBar,
  Select,
  Panel,
  DateUtils,
  FormFooter,
  ActionButton,
} from '../../components';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getStaffByMedicalServiceAndClinicalLocation } from '../../staff/selector';
import {
  setMedicalServiceRoster,
  getMedicalServiceRoster,
  resetState,
  resetStatus,
} from '../../staff/actions';
import { getSetupData, resetStatus as resetEmployerStatus } from '../../employer/actions';
import { getCurrentEmployer } from '../../../selectors/entities';

import OnCallCal from './oncall_cal';

import { HOME_TAB } from '../../../constants/tabs';

class OnCallRoster extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      rosterState: {},
      location: props.location,
      medicalService: props.medicalService,
      selectedDate: null,
      selectedRange: null,
      daysToRender: [],
      shiftsToRender: [],
    };

    const clinicalLocationMedicalService = this.locationMedicalService(props);
    this.state.clinicalLocationMedicalService = clinicalLocationMedicalService;

    this.setFocus = {};
    this.handleSelect = {};
    this._rosterItems = [];
  }

  locationMedicalService(props) {
    const locationId = props.clinicalLocations.find(
      (c) => c.name === this.state.location
    )?.employer_clinical_location_id;
    const medicalServiceId = props.medicalServices.find(
      (c) => c.name === this.state.medicalService
    )?.employer_medical_service_id;
    let clinicalLocationMedicalService = null;
    if (locationId && medicalServiceId) {
      clinicalLocationMedicalService = props.clinicalLocationMedicalServices.find(
        (clms) =>
          clms.employer_clinical_location_id === locationId &&
          clms.employer_medical_service_id === medicalServiceId
      );
      return clinicalLocationMedicalService;
    }
    return clinicalLocationMedicalService;
  }
  _buildShiftsToRender() {
    let shifts = [];
    let daysToRender = this.state.selectedRange?.length
      ? this.state.selectedRange
      : this.state.selectedDate
        ? [this.state.selectedDate]
        : [];
    if (daysToRender?.length && this.state.clinicalLocationMedicalService) {
      const shifts = this.state.clinicalLocationMedicalService.shifts || [];
      const shiftsToRender = daysToRender.reduce((result, d) => {
        const dayNum = moment(d).isoWeekday();
        const shift = shifts.find((s) => s.days.includes(dayNum));
        if (shift) {
          let resultShift = {
            ...shift,
            dates: [moment(d).format('YYYY-MM-DD')],
          };
          result.push(resultShift);
        }
        return result;
      }, []);
      this.setState({ shiftsToRender, daysToRender });
    }
  }

  handlerFactory = (id) => {
    let setFocus = this.setFocus[id];
    if (!setFocus) {
      this._rosterItems.push(id);

      setFocus = this.setFocus[id] = () => {
        this.setState({ curSelect: id });
      };
    }
    return { setFocus };
  };

  componentDidMount() {
    Utils.trackScreen('Airforce', 'Medical Service On Call Roster');
    this.props.actions.resetState();
    this.props.actions.resetEmployerStatus();
    this.props.actions.getSetupData(this.props.currentEmployer.employerId, [
      'clinicalLocations',
      'medicalServices',
      'clinicalLocationMedicalService',
    ]);
  }
  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
    this.props.actions.resetState();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.getSetupDataStatus === SUCCESS && prevProps.getSetupDataStatus !== SUCCESS) {
      const location =
        this.props.currentEmployer?.clinicalLocation || this.props.locationOptions?.[0]?.id;
      const medicalService =
        this.props.currentEmployer?.medicalService || this.props.medicalServiceOptions?.[0]?.id;
      this.state.location = location;
      this.state.medicalService = medicalService;
      const clinicalLocationMedicalService = this.locationMedicalService(this.props);
      this.setState({ location, medicalService, clinicalLocationMedicalService });
    }
    if (this.props.staffUpdateStatus === SUCCESS && prevProps.staffUpdateStatus !== SUCCESS) {
      this.setState({ rosterState: {} });
    }
    if (
      this.state.location !== prevState.location ||
      this.state.medicalService !== prevState.medicalService
    ) {
      const clinicalLocationMedicalService = this.locationMedicalService(this.props);
      this.setState({ clinicalLocationMedicalService });
    }
    if (
      this.state.selectedDate !== prevState.selectedDate ||
      this.state.clinicalLocationMedicalService !== prevState.clinicalLocationMedicalService
    ) {
      this.setState({ rosterState: {} });
      this.props.actions.resetStatus();

      this._buildShiftsToRender();
    }

    if (this.props.staffRosterUpdated !== prevProps.staffRosterUpdated) {
      const monthDate =
        (this.state.selectedDate &&
          moment(this.state.selectedDate).startOf('month').format('YYYY-MM-DD')) ||
        null;
      this._lastFetchTS = null;
      if (monthDate) this._fetchRoster(monthDate);
    }

    const monthDate =
      (this.state.selectedDate &&
        moment(this.state.selectedDate).startOf('month').format('YYYY-MM-DD')) ||
      null;
    const prevMonthDate =
      (prevState.selectedDate &&
        moment(prevState.selectedDate).startOf('month').format('YYYY-MM-DD')) ||
      null;

    if (monthDate !== prevMonthDate) {
      this._fetchRoster(monthDate);
    }

    if (this.props.screenVisible && !prevProps.screenVisible) {
      if (monthDate && this._fetchRoster(monthDate)) {
        this.setState({ rosterState: {} });
      }
    }
  }

  _fetchRoster(monthDate) {
    const nowTS = Date.now();
    if (!this._lastFetchTS || nowTS - this._lastFetchTS > 60 * 2 * 1000) {
      this._lastFetchTS = nowTS;
      this.props.actions.getMedicalServiceRoster(monthDate);
      return true;
    }
    return false;
  }

  _rosterKey = (day) => {
    const id = moment(day).format('YYYY-MM-DD');
    return `${id}_${this.state.medicalService}_${this.state.location}`;
  };

  handleSave = () => {
    if (!this.state.rosterState) return;
    const timezone = this.props.currentEmployer.timeZone;

    const roster = Object.keys(this.state.rosterState).reduce((result, rosterKey) => {
      const rosterItem = this.state.rosterState[rosterKey];
      const nextDay = DateUtils.endIsNextDay(
        rosterItem.hours.opening_time,
        rosterItem.hours.ending_time
      );
      const addDays = nextDay ? 1 : 0;
      const shift = {
        clinical_location: this.state.location,
        medical_service: this.state.medicalService,
      };
      Object.keys(rosterItem?.users || {}).forEach((userItemKey) => {
        shift[`${userItemKey}`] = rosterItem.users[userItemKey];
      });

      const dates = rosterItem?.dates || [];
      dates.forEach((date) => {
        const start_date = moment
          .tz(`${date} ${rosterItem.hours.opening_time}`, timezone)
          .toISOString();
        const end_date = moment
          .tz(`${date} ${rosterItem.hours.ending_time}`, timezone)
          .add(addDays, 'days')
          .toISOString();
        result.push({
          ...shift,
          start_date,
          end_date,
        });
      });
      return result;
    }, []);

    this.props.actions.setMedicalServiceRoster({ items: roster });
  };

  handleCancel = () => {
    this.setState({ rosterState: {} });
  };

  clearCurSelect = () => {
    this.setState({ curSelect: null });
  };

  handleDropDownOpen = () => {
    this._lastFetchTS = Date.now();
  };

  renderDropDown = (id, options, value, selectHandler, clearable = false) => {
    const { setFocus } = this.handlerFactory(id);
    const selectVal = value && !value?.id ? { id: value, label: value } : value;

    return (
      <View
        style={[styles.selectContainer, this.state.curSelect === id ? { zIndex: 1000 } : null]}
        key={id}
      >
        <Select
          id={id}
          onBlur={this.clearCurSelect}
          onFocus={setFocus}
          onValue={selectHandler}
          required={false}
          closeOnSelect={true}
          options={options}
          label={null}
          value={selectVal || null}
          webMode={true}
          isClearable={clearable}
          containerStyle={{ marginVertical: 0 }}
          noLabel={true}
          styles={SELECT_STYLE_ROUND}
          nativeStyleType="roundStyle"
          onOpen={this.handleDropDownOpen}
        />
      </View>
    );
  };

  handleSelectLocation = ({ id }) => {
    this.setState({ location: id, rosterState: {} });
  };
  handleSelectMedicalService = ({ id }) => {
    this.setState({ medicalService: id, rosterState: {} });
  };
  handleSelectedDate = (selectedDate) => {
    this.setState({ selectedDate });
  };
  handleSelectedRange = (selectedRange) => {
    this.setState({ selectedRange });
  };
  handleInfoPressFactory = (selectedId) => {
    if (!this._infoPressHandlers) this._infoPressHandlers = {};
    if (!this._infoPressHandlers[selectedId]) {
      this._infoPressHandlers[selectedId] = () => {
        this.handleInfoPress(selectedId);
      };
    }
    return this._infoPressHandlers[selectedId];
  };
  handleInfoPress = (selectedId) => {
    this._lastFetchTS = Date.now();
    Navigation.showModal({
      screen: 'OncallInfo',
      title: 'Provider Info',
      passProps: { userId: selectedId },
    });
  };

  renderDayItemDropDown = (id, label, selectHandler) => {
    const props = this.props;
    const rosterKey = id;
    const dropdownId = `${id}_${label.toLowerCase()}`;
    const optionskey = `${this.state.medicalService}_${this.state.location}`;
    const options = this.props.staffOptions[optionskey];
    const selectedId = this.state.rosterState[rosterKey]
      ? this.state.rosterState[rosterKey]?.users?.[label.toLowerCase() + '_user_id']
      : this.props.rosterState[rosterKey]?.users?.[label.toLowerCase() + '_user_id'];
    const val = selectedId
      ? { id: selectedId, label: this.props.staffNamesById[selectedId] }
      : null;
    return (
      <View style={[THEME.basicRow, this.state.curSelect === dropdownId ? { zIndex: 1000 } : null]}>
        <View style={{ width: 100, alignItems: 'flex-end' }}>
          <Text style={[THEME.textRegular, { marginRight: 10 }]}>{label}: </Text>
        </View>
        <View style={{ flex: 1, marginRight: 10 }}>
          {this.renderDropDown(dropdownId, options, val, selectHandler, true)}
        </View>
        <ActionButton
          source={ASSETS.info}
          disabled={!selectedId}
          onPress={this.handleInfoPressFactory(selectedId)}
        />
      </View>
    );
  };

  makeSelectHandler = (id, dropdownId, dates, hours) => {
    return (val) => {
      const newUserState = {
        ...this.props.rosterState[id]?.users,
        ...this.state.rosterState[id]?.users,
      };
      Object.keys(newUserState).forEach((k) => {
        if (newUserState[k] === val?.id) newUserState[k] = null;
      });
      const rosterState = {
        ...this.state.rosterState,
        [id]: {
          dates,
          hours,
          users: {
            ...newUserState,
            [dropdownId]: val?.id || null,
          },
        },
      };
      this.setState({ rosterState });
    };
  };

  renderDayItem = (days, hours, dates) => {
    const id = `${this._rosterKey(dates[0])}${hours.opening_time}${hours.ending_time}`;
    const focused = this.state.curSelect?.indexOf(id) >= 0;
    return (
      <View key={id} style={[styles.dayItemContainer, focused ? { zIndex: 100 } : null]}>
        {this.renderDayItemDropDown(
          id,
          'Primary',
          this.makeSelectHandler(id, 'primary_user_id', dates, hours)
        )}
        {this.renderDayItemDropDown(
          id,
          'Secondary',
          this.makeSelectHandler(id, 'secondary_user_id', dates, hours)
        )}
        {this.renderDayItemDropDown(
          id,
          'Alternate',
          this.makeSelectHandler(id, 'alternate_user_id', dates, hours)
        )}
      </View>
    );
  };

  renderShift = (days, hours, dates, i) => {
    let title = DateUtils.formatDateString(moment(dates[0]).toDate());
    title += ' On-Call providers';

    const timeLabel = `${hours.opening_time}-${DateUtils.endTimeLabel(
      hours.opening_time,
      hours.ending_time
    )}`;
    const timeElems = (
      <Text
        style={[
          THEME.textRegular,
          { marginRight: 10, fontSize: __WEB__ ? 16 : 14, color: COLOR.text },
        ]}
      >
        <Text style={[THEME.textSemibold, { fontSize: __WEB__ ? 16 : 14 }]}>Shift {i + 1}: </Text>
        {timeLabel}
      </Text>
    );
    const panelRight = __WEB__ ? (
      timeElems
    ) : (
      <View style={{ alignItems: 'center', width: '100%' }}>
        <Text style={[THEME.textRegular, __WEB__ ? null : { marginBottom: 7 }]}>{title}</Text>
        {timeElems}
      </View>
    );

    return (
      <Panel
        key={i}
        title={__WEB__ ? title : null}
        extraHeaderContent={panelRight}
        containerStyle={{ flex: 1, overflow: 'visible', zIndex: 1000 - i }}
        headerStyle={{ height: 70 }}
      >
        {this.renderDayItem(days, hours, dates)}
      </Panel>
    );
  };
  renderSchedule = (schedule) => {
    return schedule.hours.map((h, i) => this.renderShift(schedule.days, h, schedule.dates, i));
  };

  getEventsForCalDisplay() {
    const props = this.props;
    const rosterState = this.props.rosterState;
    const matchRosterKey = `${this.state.medicalService}_${this.state.location}`;
    const retVal = Object.keys(rosterState || {}).reduce((result, rosterKey) => {
      if (rosterKey.indexOf(matchRosterKey) >= 0) {
        const dayStr = rosterKey.split('_')[0];
        result.push({
          startDate: moment(dayStr).format(),
          endDate: moment(dayStr).add(1, 'hours').format(),
          eventName: 'test',
        });
      }
      return result;
    }, []);
    return retVal;
  }

  render() {
    const props = this.props;

    return (
      <Container
        scrollView={true}
        style={THEME.container}
        renderActivityOverlay={
          props.staffUpdateStatus === REQUESTING ||
          props.status === REQUESTING ||
          props.getSetupDataStatus === REQUESTING
        }
        errorMessage={props.errorMessage?.message || props.staffUpdateErrorMessage?.message}
        successMessage={props.staffUpdateStatus === SUCCESS ? 'Roster Saved' : null}
      >
        <View style={styles.content}>
          <Panel>
            <View style={{ width: __WEB__ ? 600 : '100%' }}>
              <View style={styles.calHeader}>
                <Text
                  style={[
                    THEME.textRegular,
                    __WEB__ ? { marginRight: 10 } : { marginHorizontal: 20, marginVertical: 20 },
                  ]}
                >
                  {__WEB__ ? 'On-Call\nSchedule:' : 'On-Call Schedule:'}
                </Text>
                <View style={styles.headerDropDowns}>
                  <View style={{ flex: 0.5 }}>
                    {this.renderDropDown(
                      'locationSelect',
                      props.locationOptions,
                      this.state.location,
                      this.handleSelectLocation
                    )}
                  </View>
                  <View style={{ flex: 0.5 }}>
                    {this.renderDropDown(
                      'medicalServiceSelect',
                      props.medicalServiceOptions,
                      this.state.medicalService,
                      this.handleSelectMedicalService
                    )}
                  </View>
                </View>
              </View>
              <OnCallCal
                onSelectedDate={this.handleSelectedDate}
                onSelectedRange={this.handleSelectedRange}
                events={this.getEventsForCalDisplay()}
              />
            </View>
          </Panel>
          <View style={{ flex: 1 }}>
            {this.state.shiftsToRender?.length ? (
              <>
                <View>
                  {this.state.shiftsToRender.map(this.renderSchedule)}
                  <View
                    style={{
                      marginHorizontal: 8,
                      marginBottom: 10,
                      borderLeftWidth: 1,
                      borderRightWidth: 1,
                      borderBottomWidth: 1,
                      borderColor: COLOR.altAccent,
                    }}
                  >
                    <FormFooter onCancel={this.handleCancel} onSave={this.handleSave} />
                  </View>
                </View>
              </>
            ) : (
              <Text style={[THEME.textRegular, { margin: 25 }]}>No shifts on this day</Text>
            )}
          </View>
        </View>
      </Container>
    );
  }
}

const styles = StyleSheet.create({
  content: __WEB__
    ? {
        flexDirection: 'row',
        alignItems: 'flex-start',
      }
    : {},
  calHeader: __WEB__
    ? {
        ...THEME.basicRow,
        backgroundColor: COLOR.altContrast,
        borderBottomWidth: 1.5,
        borderColor: COLOR.altAccent,
        paddingLeft: 20,
        paddingRight: 5,
        zIndex: 1000,
        height: 70,
      }
    : {
        backgroundColor: 'rgb(241,241,241)',
        borderBottomWidth: 1.5,
        borderColor: COLOR.altAccent,
      },
  headerDropDowns: __WEB__
    ? {
        ...THEME.basicRow,
        flex: 1,
      }
    : {
        backgroundColor: 'rgb(248,248,248)',
        borderTopWidth: 1,
        borderColor: COLOR.altAccent,
        padding: 20,
        paddingTop: 0,
      },
  selectContainer: {
    height: 60,
    paddingLeft: 7,
  },
  dayItemContainer: {
    paddingVertical: 10,
    paddingLeft: 20,
    paddingRight: 10,
  },
  dayItemContainerMultiple: {
    ...THEME.borderBottom,
  },
  day: {
    ...THEME.textMedium,
    fontSize: 14,
    textAlign: 'center',
    marginVertical: 5,
  },
});

function _optionReducer(result, current) {
  result.push({
    label: current.name,
    id: current.name,
  });
  return result;
}
function _optionSorter(a, b) {
  return a?.name?.localeCompare?.(b?.name);
}
function mapStateToProps(state, ownProps) {
  const staff = getStaffByMedicalServiceAndClinicalLocation(state);
  const staffNamesById = {};
  const staffOptions = Object.keys(staff).reduce((result, current) => {
    result[current] = (staff[current] || []).map((s) => {
      staffNamesById[s.userId] = s.fullName;
      return {
        label: s.fullName,
        id: s.userId,
      };
    });
    return result;
  }, {});

  const currentEmployer = getCurrentEmployer(state);

  const rosterState = Object.keys(state.screens.staff.medicalServiceRoster || {}).reduce(
    (result, i) => {
      const current = state.screens.staff.medicalServiceRoster[i];
      const localDate = moment
        .tz(current.start_date, currentEmployer?.timeZone)
        .format('YYYY-MM-DD');
      const opening_time = moment.tz(current.start_date, currentEmployer?.timeZone).format('HH:mm');
      const ending_time = moment.tz(current.end_date, currentEmployer?.timeZone).format('HH:mm');
      const rosterKey = `${localDate}_${current.medical_service}_${current.clinical_location}${opening_time}${ending_time}`;
      if (!result[rosterKey])
        result[rosterKey] = {
          dates: [localDate],
          hours: {
            opening_time,
            ending_time,
          },
        };

      result[rosterKey]['users'] = {
        ['primary_user_id']: current.primary_user_id,
        ['secondary_user_id']: current.secondary_user_id,
        ['alternate_user_id']: current.alternate_user_id,
      };
      return result;
    },
    {}
  );

  const clinicalLocationMedicalServices =
    state.screens.employer.setupData?.clinicalLocationMedicalService;
  const medicalServices = (state.screens.employer.setupData?.medicalServices || [])
    .slice()
    .sort(_optionSorter);
  const clinicalLocations = (state.screens.employer.setupData?.clinicalLocations || [])
    .slice()
    .sort(_optionSorter);
  const medicalServiceOptions = medicalServices.reduce(_optionReducer, []);
  const locationOptions = clinicalLocations.reduce(_optionReducer, []);

  const location = currentEmployer?.clinicalLocation || locationOptions?.[0]?.id;
  const medicalService = currentEmployer?.medicalService || medicalServiceOptions?.[0]?.id;

  return {
    medicalServiceOptions,
    locationOptions,
    staffOptions,
    status: state.screens.staff.status,
    errorMessage: state.screens.staff.errorMessage,
    staffUpdateStatus: state.screens.staff.staffUpdateStatus,
    staffUpdateErrorMessage: state.screens.staff.staffUpdateErrorMessage,
    currentEmployer,
    rosterState,
    staffNamesById,
    staffRosterUpdated: state.screens.staff.staffRosterUpdated,
    clinicalLocationMedicalServices,
    location,
    medicalService,
    medicalServices,
    clinicalLocations,
    getSetupDataStatus: state.screens.employer.getSetupDataStatus,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        setMedicalServiceRoster,
        getMedicalServiceRoster,
        resetState,
        resetStatus,
        getSetupData,
        resetEmployerStatus,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OnCallRoster);
